export const environment = {
  STRIPE_KEY:'pk_live_51NSLS5LqQm5LyPz2y6pF6vCtWOjxldMnwOOUeRADoXGRLiiIOUKeMZe9HmncKbzblpPSxgFOsxtZCyl9RrYJxqxk00N5OjJSAV',
  API_KEY : 'AIzaSyAIhgULi-bsmsovi0hVmcxLJuVjJ835Ao4',
  production: true,
  url:'https://api.prestigemovers.ca/api',
  site:'https://prestigemovers.ca/'
};
